import React from 'react';
import './breadcrumbs-dropdown.scss';
import { BreadcrumbsItemsInterface } from 'interfaces/breadcrumbs.interface';
import BreadcrumbsDropdownGroup from 'components/utilization/breadcrumbs/components/breadcrumbs-dropdown-group';

const BreadcrumbsDropdown: React.FC<{items: BreadcrumbsItemsInterface[];}> = ({ items }) => {
    const chunk = (arr: BreadcrumbsItemsInterface[], len: number): BreadcrumbsItemsInterface[][] => {
        const array = [...arr];
        const chunks = [];

        while (array.length) {
            chunks.push(array.splice(0, len));
        }

        return chunks;
    };

    return (
        <div className="breadcrumbs-dropdown">
            <div className="breadcrumbs-dropdown__content">
                {
                    chunk(items, 10).map((itemsGroup: BreadcrumbsItemsInterface[], idx: number) => (
                        <BreadcrumbsDropdownGroup key={idx.toString()} itemsGroup={itemsGroup}/>
                    ))
                }
            </div>
        </div>
    );
};

export default BreadcrumbsDropdown;
